/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Lazy loading of the component PageReportsConstructor
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import loadable from '@utils/loadable';

export default loadable(
    () => import(/* webpackChunkName: "PageReportsConstructor" */ './components/PageReportsConstructor'),
    undefined,
);
